import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { ExternalResourceService } from 'src/app/core/Services/externalresource.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialogRef } from '@angular/material';
import { ItemAddComponent, ItemForm } from '../../shared/item-add/item-add.component';
import { Router } from '@angular/router';

@Component({
    selector: 'external-resource',
    templateUrl: './external-resource.component.html',
    styleUrls: ['./external-resource.component.scss']
})

export class ExternalResourceComponent implements OnInit{
    
    ExResource: Resource[];
    constructor(private _shared: SharedService, private _er: ExternalResourceService, private _router: Router) {
        // Show loader
        this._shared.loadingState = true;
        // Setting up page title
        this._shared.pageTitle = 'External Resources';
    }

    ngOnInit() {
        this._er.getExternalResources().subscribe(res => {
            this.ExResource = <Resource[]>res['result'];
            // Hide loader
            this._shared.loadingState = false;
        });
    }

    addExternalResource() {
        const form: ItemForm = {
            title: 'Add External Resource',
            submitText: 'Add Resource',
            controls: [
                { label: 'Name', name: 'menuName', placeholder: 'eg. About, Blog', errorMsg: 'Please provide resource name.' },
                { label: 'Url', name: 'urlAddress', placeholder: 'eg. https://resource.net', errorMsg: 'Please provide resource url.' },
            ]
        }
        const ref: MatDialogRef<ItemAddComponent> = this._shared.openModal(ItemAddComponent, form);
        ref.afterClosed().subscribe(res => {
            this._er.addExternalResource(res).subscribe(result => {
                if (result['status'] === 'OK') {
                    // show loader
                    this._shared.loadingState = true;
                    // virtual reload
                    this._router.navigateByUrl('/dashboard', {skipLocationChange: true}).then(() => {
                        this._router.navigate(['/dashboard/resources']);
                    });
                }
            })
        });
    }

    // Remove external resource
    removeResource(id: number) {
        this._er.deleteExternalResource(id).subscribe(res => {
            if (res['status'] === 'OK') {
                let index = this.ExResource.findIndex(x => x.cMSMenuID === id);
                this.ExResource.splice(index, 1);
            }
        });
    }

    // Update resource sequence
    updateResourceOrder(e: CdkDragDrop<Resource[]>) {
        moveItemInArray(this.ExResource, e.previousIndex, e.currentIndex);
        const order = [];
        this.ExResource.forEach((val, index) => {
            order.push({ cmsMenuId: val['cMSMenuID'], menuPosition: index+1});
        });

        this._er.updateResourceOrder(order).subscribe(res => {
            if (res['status'] === 'OK') {
                // 
            }
        });
    }

}

export interface Resource {
    cMSMenuID: number;
    menuName: string;
    urlAddress: string;
}